import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function AudienceFit() {
  return <section className="w-full max-w-3xl mx-auto px-6 py-16" data-id="element-11">
      <div className="grid md:grid-cols-2 gap-12" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-13">
          <h3 className="text-2xl font-serif font-bold text-navy mb-6 flex items-center gap-2" data-id="element-14">
            <span className="bg-teal/20 p-1 rounded" data-id="element-15">
              <Check className="w-6 h-6 text-teal-700" data-id="element-16" />
            </span>
            ¿Para quién es?
          </h3>
          <ul className="space-y-4" data-id="element-17">
            {['Docentes de bachiller/prepa con varios grupos', 'Quienes quieren clases activas sin volverse influencers', 'Quienes necesitan resultados mañana', 'Quienes quieren recuperar tiempo sin bajar calidad'].map((item, i) => <li key={i} className="flex gap-3 text-gray-700" data-id="element-18">
                <Check className="w-5 h-5 text-teal shrink-0 mt-0.5" data-id="element-19" />
                <span data-id="element-20">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-21">
          <h3 className="text-2xl font-serif font-bold text-gray-500 mb-6 flex items-center gap-2" data-id="element-22">
            <span className="bg-red-100 p-1 rounded" data-id="element-23">
              <X className="w-6 h-6 text-red-500" data-id="element-24" />
            </span>
            ¿Para quién NO es?
          </h3>
          <ul className="space-y-4" data-id="element-25">
            {['Si solo buscas “llenar” una planeación larga para cumplir', 'Si no quieres usar estructura (prefieres improvisar siempre)', 'Si te molesta medir con evidencia corta'].map((item, i) => <li key={i} className="flex gap-3 text-gray-500" data-id="element-26">
                <X className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-27" />
                <span data-id="element-28">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}